/**
 * Два Swiper (герой + карточка), общие стрелки и пагинация на основном.
 */
import Swiper from 'swiper';
import { Autoplay, Controller, Navigation, Pagination } from 'swiper/modules';
import { initCopySkuHandler } from '../shared/copy-sku';

function parseConfig(raw) {
	if (!raw) {
		return null;
	}
	try {
		return JSON.parse(raw);
	} catch {
		return null;
	}
}

function initMainSlider(root) {
	const id = root.dataset.mainSliderId;
	if (!id || root.dataset.msReady === '1') {
		return;
	}

	const mainEl = root.querySelector(`[data-ms-main="${id}"]`);
	const cardEl = root.querySelector(`[data-ms-card="${id}"]`);
	const config = parseConfig(root.dataset.swiperConfig);

	if (!mainEl || !cardEl || !config) {
		return;
	}

	const slideCount = Math.max(0, Number(config.slideCount) || 0);
	const effectiveLoop = !!config.loop && slideCount > 1;
	const effectiveAutoplay = !!config.autoplay && slideCount > 1;
	const speed = Math.max(0, Number(config.speed) || 600);

	const mainModules = [Controller];
	if (config.showArrows) {
		mainModules.push(Navigation);
	}
	if (config.showPagination) {
		mainModules.push(Pagination);
	}
	if (effectiveAutoplay) {
		mainModules.push(Autoplay);
	}

	const cardSwiper = new Swiper(cardEl, {
		modules: [Controller],
		slidesPerView: 1,
		spaceBetween: 0,
		speed,
		loop: effectiveLoop,
		allowTouchMove: true,
		watchSlidesProgress: true,
		watchOverflow: true,
	});

	/** @type {import('swiper/types').SwiperOptions} */
	const mainOpts = {
		modules: mainModules,
		slidesPerView: 1,
		spaceBetween: 0,
		speed,
		loop: effectiveLoop,
		watchOverflow: true,
		grabCursor: true,
	};

	if (config.showArrows) {
		const prevEl = root.querySelector(`[data-ms-prev="${id}"]`);
		const nextEl = root.querySelector(`[data-ms-next="${id}"]`);
		if (prevEl && nextEl) {
			mainOpts.navigation = { prevEl, nextEl };
		}
	}

	let pagEl = null;
	if (config.showPagination) {
		pagEl = root.querySelector(`[data-ms-pag="${id}"]`);
		if (pagEl) {
			mainOpts.pagination = { el: pagEl, clickable: true };
		}
	}

	if (effectiveAutoplay) {
		mainOpts.autoplay = {
			delay: Math.max(1000, Number(config.autoplayDelay) || 5000),
			disableOnInteraction: false,
			pauseOnMouseEnter: true,
		};
	}

	const mainSwiper = new Swiper(mainEl, mainOpts);

	mainSwiper.controller.control = cardSwiper;
	cardSwiper.controller.control = mainSwiper;

	root.dataset.msReady = '1';

	const syncPaginationFromHeroText = () => {
		if (!pagEl) {
			return;
		}
		const slide = mainSwiper.slides[mainSwiper.activeIndex];
		const heroSlide = slide?.classList?.contains('wp-block-wps-blocks-main-slider__hero-slide')
			? slide
			: slide?.querySelector('.wp-block-wps-blocks-main-slider__hero-slide');
		if (!heroSlide) {
			pagEl.style.removeProperty('--wps-ms-pag-color');
			pagEl.removeAttribute('data-wps-pag-linked');
			return;
		}
		const raw = getComputedStyle(heroSlide).getPropertyValue('--wps-ms-hero-text').trim();
		if (raw) {
			pagEl.style.setProperty('--wps-ms-pag-color', raw);
			pagEl.setAttribute('data-wps-pag-linked', '1');
		} else {
			pagEl.style.removeProperty('--wps-ms-pag-color');
			pagEl.removeAttribute('data-wps-pag-linked');
		}
	};

	if (pagEl) {
		syncPaginationFromHeroText();
		mainSwiper.on('slideChange', syncPaginationFromHeroText);
		mainSwiper.on('slideChangeTransitionEnd', syncPaginationFromHeroText);
	}

	if (config.showArrows) {
		const syncArrows = () => {
			const dockArrows = root.querySelector('.wp-block-wps-blocks-main-slider__dock-arrows');
			const hide = !!mainSwiper?.isLocked;
			root.classList.toggle('wp-block-wps-blocks-main-slider--hide-arrows', hide);
			if (dockArrows) {
				dockArrows.setAttribute('aria-hidden', hide ? 'true' : 'false');
			}
		};
		mainSwiper.on('init', syncArrows);
		mainSwiper.on('resize', syncArrows);
		mainSwiper.on('breakpoint', syncArrows);
		mainSwiper.on('update', syncArrows);
		mainSwiper.on('observerUpdate', syncArrows);
		syncArrows();
	}
}

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.wp-block-wps-blocks-main-slider[data-main-slider-id]').forEach((root) => initMainSlider(root));
});

initCopySkuHandler('.wp-block-wps-blocks-main-slider .wps-product-card__copy');
